import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@tanstack/react-router';
import { LogoMobileZephyrIcon } from '@ui/custom-icons';
export function StandaloneLayout(param) {
    let { children } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "fixed inset-0 z-50 flex flex-col bg-background",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center p-8",
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        to: "/",
                        className: "flex shrink-0 items-center",
                        "aria-label": "Home",
                        children: /*#__PURE__*/ _jsx(LogoMobileZephyrIcon, {
                            width: 28,
                            height: 28
                        })
                    }),
                    /*#__PURE__*/ _jsx("hr", {
                        className: "ml-8 flex-1 h-px border-0 border-b border-border"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-1 w-full justify-center items-center",
                children: children
            })
        ]
    });
}
